import { Component, OnInit, ViewChild, Output } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
  HttpEventType,
  HttpParams,
} from "@angular/common/http";
import { Observable, Subject, merge, of } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  debounce,
} from "rxjs/operators";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
} from "@angular/forms";
import { catchError } from "rxjs/operators";
import { Router, Data, ActivatedRoute } from "@angular/router";
import { DatePipe, DecimalPipe } from "@angular/common";
import { SWAlertService } from "../../services/swalert.service";
import { BusinessDayService } from "../../services/business-day.service";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker/public_api";
import { promise } from "protractor";
import { isNullOrUndefined } from "util";
import { TSFuntionService } from "../../services/ts-funtion.service";
import { TypeaheadMatch } from "ngx-bootstrap/typeahead/ngx-bootstrap-typeahead";
import Swal from "sweetalert2";
import { async } from "rxjs/internal/scheduler/async";
import { Validatable } from "@amcharts/amcharts4/core";
import { ASTWithSource } from "@angular/compiler";
declare var Uploadfiles,
  Clearuploadfile,
  SetData,
  _Path,
  Extension: any,
  Accept: any,
  createlist: any
declare var ArrFile: any[];
@Component({
  selector: "app-ro-service-request",
  templateUrl: "./ro-service-request.component.html",
  providers: [DatePipe, TSFuntionService, DecimalPipe],
})
export class ROServiceRequestComponent implements OnInit {
  arrRequestType = [];
  isHiddenDelete: boolean = true;
  isHiddenRecall: boolean = true;
  isHiddenSubmit: boolean = false;
  isHiddenDraft: boolean = false;
  sComment: string = null;
  sRequestCode: string = null;
  sRequestType: string = null;
  sExpectedCompleteDate: string = null;
  sRemarkToSSC: string = null;
  TODAY: Date;
  dLeastDate : Date;
  sReqID: any;
  bsConfig: Partial<BsDatepickerConfig>; //Set congic datepicker เท่านั้น ส่วน daterangpicker จะใช้อีก confic หนึ่ง
  ROServiceForm: FormGroup;
   
  fileType: any;
  limit: any;

  constructor(
    private http: HttpClient,
    private formBuilder: FormBuilder,
    public datePipe: DatePipe,
    private SW: SWAlertService,
    private BusinessDay: BusinessDayService,
    private _decimalPipe: DecimalPipe,
    private System: TSFuntionService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {}

  async ngOnInit() {
    this.System.BlockUI();
    this.TODAY = new Date();
    this.ROServiceForm = this.formBuilder.group({
      sRequestID: [null],
      nReqType: ['', Validators.required],
      dExpectedCompleteDate: [null, Validators.required],
      sRemarkSSC: [null],
    });
    //confic datepicker
    this.bsConfig = Object.assign(
      {},
      {
        containerClass: "theme-dark-blue", //set theme
        dateInputFormat: "DD/MM/YYYY", //set Format
        showWeekNumbers: false,
      }
    );
    this.activatedRoute.queryParams.subscribe(async (params) => {
      let ID: string = this.System.GetQuerySTR("ros");
      this.sReqID = await this.System.Decrypt(ID);
      this.Edit(this.sReqID);
    });
    await this.getFileType();
    await this.getFileLimit();
    var setUp = {
      sID: "dvFile",
      nFileSize: 15,
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true,
      ArrFile: ArrFile,
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limit,
    };

    Uploadfiles(setUp);
    Clearuploadfile();
    this.SetDataOnPageLoad();
  }

  SetDataOnPageLoad() {
    this.http
    .get<any>(this.System.SiteName + "api/ROService/_GetRequestType")
    .subscribe((res) => {
      this.arrRequestType = res;
    });
    this.System.UnBlockUI();
  }

  checkFile() {
    if (ArrFile.filter((f) => f.IsDelete === false).length > 0) {
      const chkFile = document.getElementById("dvFile");
      chkFile.style.border = "1px solid #dde4f6";
    }
    return "";
  }

  async getFileType() {
    await this.http
      .get(this.System.SiteName + "api/FileConfig/FileType")
      .toPromise()
      .then((data: Response) => {
        const result = [];
        const item = Object.values(data);
        for (let x = 0; x < item.length; x++) {
          if (data[x]["sValue"] === "Y") {
            result.push(data[x]["sValueText"]);
          }
        }
        this.fileType = result;
      });
  }

  async getFileLimit() {
    await this.http
      .get(this.System.SiteName + "api/FileConfig/FileLimit")
      .toPromise()
      .then((data: Response) => {
        const result = [];
        const item = Object.values(data);
        for (let x = 0; x < item.length; x++) {
          result.push(data[x]["sValue"]);
        }
        this.limit = result;
      });
  }

  async Save(mode) {
    let _this = this;
    let roServiceForm = _this.ROServiceForm;
    let IsValid: boolean = true;
    if (ArrFile.filter((f) => f.IsDelete === false).length <= 0 && mode !== 1) {
      IsValid = false;
      const chkFile = document.getElementById('dvFile');
      chkFile.style.border = "1px solid red";
    }
    
    if ([1, 2].includes(mode)) {
      let FieldValid: string[] = ['nReqType'];
      FieldValid.forEach(function (Field) {
        if (!roServiceForm.get(Field).valid && roServiceForm.get(Field).disabled == false) {
          IsValid = false;
        }
        const control = roServiceForm.get(Field);
        if (control instanceof FormControl && control.status != "DISABLED") {
          control.markAsTouched({ onlySelf: true });
        }
      });
    }
   
    if (IsValid) {
      let DataSave = {
        TRequest: {
          sRequestID: roServiceForm.get('sRequestID').value,
          nReqType: roServiceForm.get('nReqType').value,
          dExpectedCompleteDate: _this.datePipe.transform(roServiceForm.get('dExpectedCompleteDate').value, 'dd/MM/yyyy'),
          sRemarkSSC: roServiceForm.get('sRemarkSSC').value,
          nStatusID: mode,
        },
        FileUp: ArrFile,
      }

      let Data = JSON.stringify(DataSave)

      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/ROService/Save", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _this.System.UnBlockUI();
            _this.SW.SwAlert.Success(_this.SW.BoxMsg.Title_Success, _this.SW.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["ro-service"]) });
          } else {
            _this.System.UnBlockUI();
          }
        });
      }
      this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }

  async Edit(sReqID) {
    let _this = this;
    this.System.BlockUI();
    let Isnull = sReqID == "" ? true : false;
    if (!Isnull) {
      let data: any;
      await _this.http.get(_this.System.SiteName + "api/ROService/GetRequest/" + sReqID + "").toPromise().then(Data => data = Data)
      if(data != null){
        _this.dLeastDate = _this.convertToDate(data[0].dExpectedCompleteDate);
        _this.ROServiceForm.patchValue({
          sRequestID: data[0].sRequestID,
          nReqType: data[0].nReqType.toString(),
          dExpectedCompleteDate: _this.convertToDate(data[0].dExpectedCompleteDate),
          sRemarkSSC: data[0].sRemarkSSC,
        });
        _this.sRequestCode = data[0].sRequestCode;
        _this.sComment = data[0].sComment;
        let file: any;
        await _this.http.get(_this.System.SiteName + "api/_Paytovendor/Getfile/" + sReqID + "").toPromise().then(Data => file = Data);
        if (file) {
          let arr = [];
          if (file.length != 0) {
            file.forEach(f => arr.push({
              nID: f.nFileOrder,
              sPath: f.sPathFile,
              sSystemFileName: f.sSystemFileName,
              sFileName: f.sFileName,
              sSize: +f.sFileSize,
            }))
            SetData('dvFile', arr)
          }
        }
        switch (data[0].nStatusID) {
          case 1:
          case 3:
          case 4:
            _this.isHiddenDelete = false
            break;
          case 2:
          case 5:
            if (data[0].nStatusID === 2)_this.isHiddenRecall = false;
            _this.isHiddenSubmit = true;
            _this.isHiddenDraft  = true;
            let arr = _this.arrRequestType.filter(f => f.sValue === data[0].nReqType.toString())
            if (arr) _this.sRequestType = arr[0].sText;
            _this.sExpectedCompleteDate = data[0].dExpectedCompleteDate
            _this.sRemarkToSSC = data[0].sRemarkSSC;
            _this.ROServiceForm.get('nReqType').disable();
            _this.ROServiceForm.get('dExpectedCompleteDate').disable();
            _this.ROServiceForm.get('sRemarkSSC').disable();

            _this.getFile(data[0].sRequestID);

            break;
        }

      }
    }
    else{
      _this.ROServiceForm.patchValue({ dExpectedCompleteDate: this.TODAY });
      _this.dLeastDate = new Date();
    }
  }

  getFile(index) {
    this.http.get<any>(this.System.SiteName + "api/ROService/GetFle/" + index).subscribe(res => {
      let data = res.File;
      let arr: any[] = [];
      if (data) {
        data.forEach(f => arr.push({
          nID: f.nFileOrder,
          sPath: f.sPathFile,
          sSystemFileName: f.sSystemFileName,
          sFileName: f.sFileName,
          sSize: parseInt(f.sFileSize),
          IsNew: false
        }))
        createlist("dvFile", arr);
      }
    });
  }

  Back() {
    this.router.navigate(["/ro-service"]);
  }

  convertToDate(dDate) {
    let chunks = dDate.split('/');
    return new Date(chunks[1] + '-' + chunks[0] + '-' + chunks[2]);
  }

  isFieldValid(_Field: string) {
    return (
      !this.ROServiceForm.get(_Field).valid &&
      this.ROServiceForm.get(_Field).touched
    );
  }
  displayFieldCss(_Field: string) {
    return {
      "has-error": this.isFieldValid(_Field),
      "has-feedback": this.isFieldValid(_Field),
    };
  }
}
